import { Component } from '@angular/core';
import { CustomerViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/customer-view/customer-view-wrapper.component';

@Component({
  selector: 'app-customer-view-mobile',
  templateUrl: './customer-view-mobile.component.html',
  styleUrls: ['./customer-view-mobile.component.scss'],
})
export class CustomerViewMobileComponent extends CustomerViewWrapperComponent {
}
